function sectionJavascriptRun(){
  
  if (window.initLazyImages) {
    window.initLazyImages();
  }

  //slider-header-mobile-navigation
  if(document.querySelector('.header-mobile-navigation .header_mobile_navigation_slider.swiper')){
    document.querySelectorAll('.header-mobile-navigation .header_mobile_navigation_slider.swiper:not(.swiper-initialized)').forEach(function (this_elem) {
      var activeSlide = this_elem.querySelector('.swiper-slide.active'),
          activeIndex = activeSlide ? [...activeSlide.parentElement.children].indexOf(activeSlide) : 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: false,
        freeMode: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        initialSlide: activeIndex
      });

      this_elem.addEventListener('click', function(e) {
        const slide = e.target.closest('.swiper-slide');
        if (!slide) return;
        const index = [...slide.parentElement.children].indexOf(slide);
        setTimeout(() => {
          sectionSwiperSlider.slideTo(index, 300);
        }, 0);
      });
    });
  }

  //slider-product-grid
  if(document.querySelector('.slider-product-grid .swiper_slider_product_grid.swiper')){
    document.querySelectorAll('.slider-product-grid .swiper_slider_product_grid.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap,
              slidesPerGroup: 1
            },
            749: {
              spaceBetween: desktopGap,
              slidesPerGroup: 4
            }
        }
      });
    });
  }

  //custom-product-recommendations slider-product-grid
  if(document.querySelector('.custom-product-recommendations .swiper_slider_product_grid.swiper')){
    document.querySelectorAll('.custom-product-recommendations .swiper_slider_product_grid.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap,
              slidesPerGroup: 1
            },
            749: {
              spaceBetween: desktopGap,
              slidesPerGroup: 4
            }
        }
      });
    });
  }

  //slider-product-grid
  if(document.querySelector('.recently-viewed-product-grid .swiper_recently_viewed_product_grid.swiper')){
    document.querySelectorAll('.recently-viewed-product-grid .swiper_recently_viewed_product_grid.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap,
              slidesPerGroup: 1
            },
            749: {
              spaceBetween: desktopGap,
              slidesPerGroup: 4
            }
        }
      });
    });
  }

  //selling-key-points
  if(document.querySelector('.selling-key-points .block_swiper.swiper')){
    document.querySelectorAll('.selling-key-points .block_swiper.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap
            },
            749: {
              spaceBetween: desktopGap
            }
        }
      });
    });
  }

  //shop-by-budget
  if(document.querySelector('.shop-by-budget .block_swiper.swiper')){
    document.querySelectorAll('.shop-by-budget .block_swiper.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap
            },
            749: {
              spaceBetween: desktopGap
            }
        }
      });
    });
  }

  //collection-tab-product-grid --> tab slider
  if(document.querySelector('.collection-tab-product-grid .tab_list_header.swiper')){
    document.querySelectorAll('.collection-tab-product-grid .tab_list_header.swiper:not(.swiper-initialized)').forEach(function (this_elem){
      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: 8,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest(".tab_list_header").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest(".tab_list_header").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: 14
            },
            749: {
              spaceBetween: 8
            }
        }
      });
    });
  }

  //collection-tab-product-grid --> tab content slider
  if(document.querySelector('.collection-tab-product-grid .swiper_collection_tab_product_grid.swiper')){
    document.querySelectorAll('.collection-tab-product-grid .swiper_collection_tab_product_grid.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest(".single_tab_content").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest(".single_tab_content").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap,
              slidesPerGroup: 1
            },
            749: {
              spaceBetween: desktopGap,
              slidesPerGroup: 4
            }
        }
      });
    });
  }

  //collection-tab-product-grid --> tab control
  if(document.querySelector('.collection-tab-product-grid .section_content .single_tab')){
    document.querySelectorAll('.collection-tab-product-grid .section_content .single_tab').forEach(function (this_elem){
      this_elem.addEventListener("click",function(){
        var data_tab_id = this_elem.getAttribute("data_tab_id");
        this_elem.closest(".collection-tab-product-grid").querySelectorAll(".section_content .single_tab.active").forEach(function (inside_this_elem){
          inside_this_elem.classList.remove("active");
        });

        this_elem.classList.add("active");

        this_elem.closest(".collection-tab-product-grid").querySelectorAll(".section_content .single_tab_content").forEach(function (inside_this_elem){
          inside_this_elem.classList.add("hidden");
        });

        if(this_elem.closest(".collection-tab-product-grid").querySelector(`.section_content .single_tab_content[data_tab_id="${data_tab_id}"]`)){
          this_elem.closest(".collection-tab-product-grid").querySelector(`.section_content .single_tab_content[data_tab_id="${data_tab_id}"]`).classList.remove("hidden");
        }
      });
    });
  }

  //product-page-tabs-section --> tab slider
  if(document.querySelector('.product-page-tabs-section .tab_list_header.swiper')){
    document.querySelectorAll('.product-page-tabs-section .tab_list_header.swiper:not(.swiper-initialized)').forEach(function (this_elem){
      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest(".tab_list_header").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest(".tab_list_header").querySelector(".slider_controls .prev_arrow_button")
        }
      });
    });
  }
  
  //product-page-tabs-section --> tab content slider
  if(document.querySelector('.product-page-tabs-section .swiper_product_page_tabs_section.swiper')){
    document.querySelectorAll('.product-page-tabs-section .swiper_product_page_tabs_section.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest(".single_tab_content").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest(".single_tab_content").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap,
              slidesPerGroup: 1
            },
            749: {
              spaceBetween: desktopGap,
              slidesPerGroup: 4
            }
        }
      });
    });
  }

  //product-page-tabs-section --> tab control
  if(document.querySelector('.product-page-tabs-section .section_content .single_tab')){
    document.querySelectorAll('.product-page-tabs-section .section_content .single_tab').forEach(function (this_elem){
      this_elem.addEventListener("click",function(){
        var data_tab_id = this_elem.getAttribute("data_tab_id");
        this_elem.closest(".product-page-tabs-section").querySelectorAll(".section_content .single_tab.active").forEach(function (inside_this_elem){
          inside_this_elem.classList.remove("active");
        });
        this_elem.classList.add("active");

        this_elem.closest(".product-page-tabs-section").querySelectorAll(".section_content .single_tab_content").forEach(function (inside_this_elem){
          inside_this_elem.classList.add("hidden");
        });

        if(this_elem.closest(".product-page-tabs-section").querySelector(`.section_content .single_tab_content[data_tab_id="${data_tab_id}"]`)){
          this_elem.closest(".product-page-tabs-section").querySelector(`.section_content .single_tab_content[data_tab_id="${data_tab_id}"]`).classList.remove("hidden");
        }
      });
    });
  }

  //cart-drawer-tabs-section --> tab slider
  if(document.querySelector('.cart_drawer_tabs .tab_list_header.swiper')){
    document.querySelectorAll('.cart_drawer_tabs .tab_list_header.swiper:not(.swiper-initialized)').forEach(function (this_elem){
      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest(".tab_list_header").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest(".tab_list_header").querySelector(".slider_controls .prev_arrow_button")
        }
      });
    });
  }
  
  //cart-drawer-tabs-section --> tab content slider
  if(document.querySelector('.cart_drawer_tabs .swiper_cart_drawer_tabs.swiper')){
    document.querySelectorAll('.cart_drawer_tabs .swiper_cart_drawer_tabs.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest(".single_tab_content").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest(".single_tab_content").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap
            },
            749: {
              spaceBetween: desktopGap
            }
        }
      });
    });
  }
  
  //cart-drawer-tabs-section --> tab control
  if(document.querySelector('.cart_drawer_tabs .section_content .single_tab')){
    document.querySelectorAll('.cart_drawer_tabs .section_content .single_tab').forEach(function (this_elem){
      this_elem.addEventListener("click",function(){
        var data_tab_id = this_elem.getAttribute("data_tab_id");
        this_elem.closest(".cart_drawer_tabs").querySelectorAll(".section_content .single_tab.active").forEach(function (inside_this_elem){
          inside_this_elem.classList.remove("active");
        });
        this_elem.classList.add("active");

        this_elem.closest(".cart_drawer_tabs").querySelectorAll(".section_content .single_tab_content").forEach(function (inside_this_elem){
          inside_this_elem.classList.add("hidden");
        });

        if(this_elem.closest(".cart_drawer_tabs").querySelector(`.section_content .single_tab_content[data_tab_id="${data_tab_id}"]`)){
          this_elem.closest(".cart_drawer_tabs").querySelector(`.section_content .single_tab_content[data_tab_id="${data_tab_id}"]`).classList.remove("hidden");
        }
      });
    });
  }

  //slider-image-with-text-block
  if(document.querySelector('.slider-image-with-text-block .slider_image_with_text_inner.swiper')){
    document.querySelectorAll('.slider-image-with-text-block .slider_image_with_text_inner.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        pagination: {
            el: this_elem.closest('section.shopify-section').querySelector('.swiper_pagination'),
            clickable: true
        },
        navigation: {
            nextEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest("section.shopify-section").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap
            },
            749: {
              spaceBetween: desktopGap
            }
        }
      });
    });
  }
  
  //hero-banner-slider-1
  if(document.querySelector('.hero-banner-slider-1 .banner_swiper.swiper')){
    document.querySelectorAll('.hero-banner-slider-1 .banner_swiper.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: 1,
        spaceBetween: desktopGap,
        autoHeight:true,
        freeMode: false,
        loop: true,
        pagination: {
            el: this_elem.closest('section.shopify-section').querySelector('.slider_dots'),
            clickable: true
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap
            },
            749: {
              spaceBetween: desktopGap
            }
        }
      });
    });
  }

  //hero-banner-slider-2
  if(document.querySelector('.hero-banner-slider-2 .banner_swiper.swiper')){
    document.querySelectorAll('.hero-banner-slider-2 .banner_swiper.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: 1,
        spaceBetween: desktopGap,
        loop: true,
        breakpoints: {
            0: {
              spaceBetween: mobileGap
            },
            749: {
              spaceBetween: desktopGap
            }
        }
      });
    });
  }

  //hero-banner-slider-3
  if(document.querySelector('.hero-banner-slider-3 .banner_swiper.swiper')){
    document.querySelectorAll('.hero-banner-slider-3 .banner_swiper.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: 1,
        spaceBetween: desktopGap,
        loop: true,
        breakpoints: {
            0: {
              spaceBetween: mobileGap
            },
            749: {
              spaceBetween: desktopGap
            }
        }
      });
    });
  }

  //predictive-search collection_swiper
  if(document.querySelector('predictive-search .collection_swiper.swiper')){
    document.querySelectorAll('predictive-search .collection_swiper.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        slidesPerGroup: 3,
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest(".header_collections").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest(".header_collections").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              enabled: false,
              spaceBetween: mobileGap
            },
            749: {
              enabled: true,
              spaceBetween: desktopGap
            }
        }
      });
    });
  }

  //predictive-search swiper_slider_product_grid
  if(document.querySelector('predictive-search .swiper_slider_product_grid.swiper')){
    document.querySelectorAll('predictive-search .swiper_slider_product_grid.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest(".header_products").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest(".header_products").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap,
              slidesPerGroup: 1
            },
            749: {
              spaceBetween: desktopGap,
              slidesPerGroup: 4
            }
        }
      });
    });
  }
  
  //predictive-search recently_viewed_product_card_swiper
  if(document.querySelector('predictive-search .recently_viewed_product_card_swiper.swiper')){
    document.querySelectorAll('predictive-search .recently_viewed_product_card_swiper.swiper:not(.swiper-initialized)').forEach(function (this_elem) {    
      var desktopGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-desktop')) || 0,
          mobileGap = parseInt(getComputedStyle(this_elem).getPropertyValue('--gap-mobile')) || 0;

      const sectionSwiperSlider = new Swiper(this_elem, {
        slidesPerView: "auto",
        spaceBetween: desktopGap,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: this_elem.closest(".recently_viewed_product_card_inner").querySelector(".slider_controls .next_arrow_button"),
            prevEl: this_elem.closest(".recently_viewed_product_card_inner").querySelector(".slider_controls .prev_arrow_button")
        },
        breakpoints: {
            0: {
              spaceBetween: mobileGap,
              slidesPerGroup: 1
            },
            749: {
              spaceBetween: desktopGap,
              slidesPerGroup: 4
            }
        }
      });
    });
  }
  
  //product_tab_inner
  if(document.querySelector('.product_tab_inner .tab_title')){
    document.querySelectorAll('.product_tab_inner .tab_title').forEach((tab) => {
      tab.addEventListener('click', () => {
        tab.closest('.product_tab_inner').querySelectorAll('.active').forEach((el) => el.classList.remove('active'));
        tab.classList.add('active');
        var data_tab = tab.getAttribute('data_tab');
        if(tab.closest('.product_tab_inner').querySelector(`.tab_content_inner[data_tab="${data_tab}"]`)){
          tab.closest('.product_tab_inner').querySelector(`.tab_content_inner[data_tab="${data_tab}"]`).classList.add('active');
        }
      });
    });
  }
  
  // Sticky ATC Height
  if(document.querySelector('#shopify-section-sticky-atc')){
    var height = document.querySelector('#shopify-section-sticky-atc').offsetHeight;
    document.querySelector(':root').style.setProperty('--sticky-atc-height', `${height}px`);
  }else{ 
    document.querySelector(':root').style.setProperty('--sticky-atc-height', `0px`);
  }

}

document.addEventListener('shopify:section:load', sectionJavascriptRun);
document.addEventListener('DOMContentLoaded', sectionJavascriptRun);